

import { useEffect, useState, useMemo, useContext, useRef } from "react";
// import { isnofferwallapi } from "../../config/axios/axiosconfig";
import Common from "./common";
// import { useParams } from "react-router-dom";
// import { uuid } from "uuidv4";
// import PageHeader from "../../components/masterlayout/PageHeader";
// import "./profile.css";
import { useTable, useGlobalFilter, useFilters, useSortBy, usePagination } from "react-table";
// import FilterForm from "./filters";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
//import { useNavigate } from "react-router-dom";
import { ClientContext } from "../../context/client/ClientContext";
import { offerwallapi } from "../../config/axiosconfig";
import axios from "axios";
import { LanguageContext } from "../../context/language/LanguageContext";
import { TenantContext } from "../../context/tenant/TenantContext";

import './cashback.css'
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

// const statuses = [
// 	{
// 		id: 1,
// 		name: "Pending",
// 	},
// 	{
// 		id: 2,
// 		name: "Confirm",
// 	},
// 	{
// 		id: 3,
// 		name: "Reject",
// 	},
// ];


export default function Cashback({ cbRewardList, cbMerchantList, setHideCommon }) {


	const breadcrumbs = [
		{ label: "Home", path: "/" },
		{ label: "Cashback Overview", path: "/user/cashback" }, // Do not include the current page here
	];
	const { client } = useContext(ClientContext);
	const { language } = useContext(LanguageContext);
	const { tenant } = useContext(TenantContext);


	// const [RewardsInfo, setRewardsInfo] = useState();
	// const [getMerchantList, setMerchantList] = useState();
	const [filteredRewards, setFilteredRewards] = useState([]);
	const [filteredRewardsMob, setFilteredRewardsMob] = useState([]);

	// const [baseRewardValue, setBaseRewardValue] = useState();

	const [filterDates, setFilterDates] = useState();//[new Date(), new Date()])
	const [filterMerchant, setFilterMerchant] = useState(0);

	const [showhidePicker, setShowHidePicker] = useState("d-none");

	const [selectedTransaction, setSelectedTransaction] = useState({});
	const [hideOverview, sethideOverview] = useState("d-block");
	const [showDetail, setshowDetail] = useState("d-none");

	const [showFilter, setShowFilter] = useState(false);


	const filRefCatW = useRef();
	const filRefCatM = useRef();
	const filRefDateW = useRef();

	//const [startDate, setStartDate] = useState();baseRewardValue
	// const [euid, setEUID] = useState(client?.euid || "");

	// useEffect(() => {
	// 	if (client) {
	// 		setEUID(client.externaluserid);
	// 		// getRewardInfo();
	// 	}
	// }, [client]);



	// const FilterRewards = () => {

	// 	const fr = [];
	// 	const frm = [];
	// 	for (let i = 0, j = cbRewardList.length; i < j; i++) {

	// 		fr.push(<tr>
	// 			<td scope="row">{cbRewardList[i].id}</td>
	// 			<td>
	// 				<div className="row">
	// 					<img src={cbRewardList[i].merchantImage}
	// 						className="rounded-circle" style={{ width: "50px", height: "50px" }} />
	// 					<div className="col">{cbRewardList[i].merchantName}</div>
	// 				</div>
	// 			</td>
	// 			<td>{cbRewardList[i].txDateUtc}</td>
	// 			<td className="text-end">{cbRewardList[i].txAmount}</td>
	// 			<td className="text-end">{cbRewardList[i].rewardAmount}</td>
	// 			<td>View</td>

	// 		</tr>);

	// 		frm.push(
	// 			<div className="row g-0">
	// 				<div class="border m-auto rounded-circle show" style={{
	// 					fontSize: "50px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "50px", height: "50px"
	// 				}}>
	// 					<img src={`${cbRewardList[i].merchantImage}`} className="d-block ms-auto me-auto" style={{ marginTop: "20px" }} />
	// 				</div>

	// 				<div className="fs-12 col">
	// 					<div>
	// 						<strong>{cbRewardList[i].merchantName}</strong><br />
	// 						{cbRewardList[i].txDateUtc}
	// 					</div>
	// 				</div>
	// 				<div className="fs-12 col text-end">
	// 					{cbRewardList[i].rewardAmount}
	// 				</div>
	// 			</div>
	// 		)

	// 		if (cbRewardList[i].bonusAmount >= 0) {
	// 			fr.push(<tr>
	// 				<td scope="row">{cbRewardList[i].id}</td>
	// 				<td>
	// 					<div className="row">
	// 						<img src={cbRewardList[i].merchantImage}
	// 							className="rounded-circle" style={{ width: "50px", height: "50px" }} />
	// 						<div className="col">Bonus Cashback</div>
	// 					</div>
	// 				</td>
	// 				<td>{cbRewardList[i].bonusRewardDate}</td>
	// 				<td></td>
	// 				<td>{cbRewardList[i].bonusAmount}</td>
	// 				<td>View</td>
	// 			</tr>);

	// 			frm.push(
	// 				<div className="row g-0">
	// 					<div class="border m-auto rounded-circle show" style={{
	// 						fontSize: "50px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "50px", height: "50px"
	// 					}}>
	// 						<img src={`${cbRewardList[i].merchantImage}`} className="d-block ms-auto me-auto" style={{ marginTop: "20px" }} />
	// 					</div>

	// 					<div className="fs-12 col">
	// 						<div>
	// 							<strong>Bonus Cashback</strong><br />
	// 							{cbRewardList[i].txDateUtc}
	// 						</div>
	// 					</div>
	// 					<div className="fs-12 col text-end">
	// 						{cbRewardList[i].bonusAmount}
	// 					</div>
	// 				</div>
	// 			)
	// 		}
	// 	}

	// 	setFilteredRewards(fr.join(""));
	// 	setFilteredRewardsMob(frm.join(""));

	// }

	const setEligibleFlag = (revList) => {

		for (let i = 0, j = revList.length; i < j; i++) {
			const tranId = revList[i].transactionId;
			if (!revList[i].reward_id) {
				for (let k = 0, l = revList.length; k < l; k++) {
					const tranId2 = revList[k].transactionId;
					if (tranId === tranId2 && i !== k) {
						revList[i].isEligible = true;
						break;
					}
				}
			}
		}

		setFilteredRewards(revList)

	}

	useEffect(() => {
		if (cbRewardList) {
			// setRewardsInfo(rewards)
			// FilterRewards();
			setEligibleFlag(cbRewardList)

		} else {
			// setFilteredRewards(
			// 	<tr><td colspan='6' className="text-center">No Rewards</td></tr>
			// )
		}

	}, [cbRewardList])

	const changeDates = (item) => {
		// const fd = item;
		if (item) {
			let endDate = item[1];
			endDate = new Date(new Date(endDate).setHours(23));
			endDate = new Date(new Date(endDate).setMinutes(59));
			endDate = new Date(new Date(endDate).setSeconds(59));

			item[1] = endDate
			// console.log(item.selection);
		}
		setFilterDates(item);
		// filterRewards();
		// filRefDateW.current.value = item[0].toLocaleDateString() + " - " + item[1].toLocaleDateString()
	}

	useEffect(() => {
		filterRewards(filterMerchant);
	}, [filterDates]);

	const filterRewards = (val) => {
		setFilterMerchant(val);
		if (!val) {
			val = 0;
		}

		let filMerchant = val;

		const fCDataList = [];
		cbRewardList?.map((rew, index) => {
			if (filMerchant != "0") {
				if (filMerchant === rew.merchantId) {
					fCDataList.push(rew);
				}

			} else {
				fCDataList.push(rew)
			}

		});

		if (filterDates) {
			const filDates = filterDates;

			const sDate = filDates[0];
			const eDate = filDates[1];
			const fDDataList = []
			fCDataList?.map((fcrew) => {
				// console.log("end date : ", eDate)
				if (eDate) {

					if (fcrew.reward_id && fcrew.bonusRewardDate) {
						// console.log("bonus reward date : ", fcrew)

						// console.log("bonus br>= sDate : ", new Date(fcrew.bonusRewardDate?.split("T")[0] + " 23:59:59"), eDate)
						// console.log("bonus br>= sDate : ", new Date(fcrew.bonusRewardDate?.split("T")[0] + " 23:59:59").getTime() <= eDate.getTime())

						if (new Date(fcrew.bonusRewardDate).getTime() >= sDate.getTime()
							&& new Date(fcrew.bonusRewardDate).getTime() <= eDate.getTime()) {
							fDDataList.push(fcrew);
						}
					} else {
						// console.log("transaction date : ", fcrew.txDateUtc)

						if (new Date(fcrew.txDateUtc).getTime() >= sDate.getTime()
							&& new Date(fcrew.txDateUtc).getTime() <= eDate.getTime()) {
							fDDataList.push(fcrew);
						}
					}
				} else {
					fDDataList.push(fcrew);

				}

			});
			//setFilteredRewards(fDDataList)
			setEligibleFlag(fDDataList);
		} else {
			//setFilteredRewards(fCDataList)
			setEligibleFlag(fCDataList);
		}

	}

	return (
		<div className="col-md-9  isn-bradius bg-white">

			<div className={`${hideOverview} border rounded-3 p-3 mt-3 mt-md-0`}>
				<div>
					<h5 className="mb-4 fs-16 fw-bold d-inline-block">{language?.static_labels.cashback_overview}</h5>
					<div className={`${(showFilter) ? "bg-primary" : ""} float-end fs-16 p-2 rounded-circle text-black d-block d-md-none`}
						onClick={() => { setShowFilter((!showFilter)) }}
						style={{ marginTop: "-8px" }}><i class="bi bi-filter"></i></div>
				</div>
				{/* START <!-- Desktop-specific content here --> */}
				<div className="d-none d-md-block">
					<div>
						<div className="row">
							<div className="col">
								<label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_by_date}</label>
								<div>
									<div className={`bg-white border border-1 d-inline-block rounded-1 form-control`}>
										<DateRangePicker
											locale={language?.languagecodedate}
											onChange={item => {
												changeDates(item);
											}}
											value={filterDates}
											dayPlaceholder="DD"
											monthPlaceholder="MM"
											yearPlaceholder="YY"
											rangeDivider="-"
											format="yyyy/MM/dd"
											className={"fs-12"}
										/>
									</div>
								</div>

							</div>

							<div className="col">
								<label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_by_merchant}</label>
								<div>
									<select className="form-select fs-12" ref={filRefCatW} onChange={(event) => filterRewards(event.target.value)}>
										<option value="0">{language?.static_labels.overview_all_merchants}</option>
										{

											cbMerchantList?.map((merchant) => {
												return <option value={merchant.merchantId}>{merchant.merchantName}</option>
											})
										}
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className="row fs-12 mt-3">
						<div className="text-end">
							<div className="d-inline-block" style={{ width: "max-content" }}>
								<i class="bi bi-circle-fill me-2 cachback_status_success"></i>{language?.static_labels.overview_status_success}
							</div>
							<div className="d-inline-block ms-3" style={{ width: "max-content" }}>
								<i class="bi bi-circle-fill me-2 cachback_status_pending"></i>{language?.static_labels.overview_status_pending}
							</div>
							{/* <div className="d-inline-block ms-3" style={{ width: "max-content" }}>
								<i class="bi bi-circle-fill me-2 cachback_status_failed"></i>{language?.static_labels.overview_status_failed}
							</div> */}
						</div>
					</div>
					<hr />
					<div className="table-responsive">
						<table className="table" style={{ width: "100%" }}>
							<thead>
								<tr className="fs-13 text-start">
									<th className="text-ellipsis">{language?.static_labels.overview_table_id}</th>
									<th className="text-ellipsis">{language?.static_labels.overview_table_merchant}</th>
									<th className="text-ellipsis">{language?.static_labels.overview_transation_date}</th>
									<th className="text-ellipsis">{language?.static_labels.overview_table_card_last4_alias}</th>
									<th className="text-ellipsis">{language?.static_labels.overview_table_transaction_amount}</th>
									<th className="text-ellipsis">{language?.static_labels.overview_table_cashback}</th>
									<th className="text-ellipsis">{language?.static_labels.overview_table_action}</th>
								</tr>
							</thead>
							<tbody className="fs-12">
								{
									filteredRewards?.map((rew, index) => {
										return (rew.reward_id == null) ?
											(rew.rewardStatus === "REWARD ISSUED"
												|| rew.rewardStatus === "CREDIT PENDING"
												|| rew.rewardStatus === "CREDIT SUCCESSFUL"
												|| rew.rewardStatus === "CREDIT UNSUCCESSFUL"
												|| rew.rewardStatus === "CREDIT FAILED") ?
												<tr>
													<td scope="row" className="align-content-center">{rew.transactionId}</td>
													<td className="align-content-center">

														{
															rew.target_group === "MERCHANT" ?
																<div className="row">
																	<img src={rew.offerLogo === "" || rew.offerLogo === null  ? rew.merchantImage : rew.offerLogo}
																		className="rounded-circle" style={{ width: "75px", height: "50px" }} />
																	<div className="col fw-bold align-content-center">{rew.merchantName}</div>
																</div>
																// <div className="row">
																// 	<img src={rew.offerLogo === "" || rew.offerLogo === null  ? `${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_merchant_offer.png` : rew.offerLogo}
																// 		className="rounded-circle" style={{ width: "75px", height: "50px" }} />
																// 	<div className="col fw-bold align-content-center">{
																// 		rew.merchantName && rew.merchantName !== null ? rew.merchantName : language?.static_labels.agnostic_merchant_offer
																// 	}</div>
																// </div>
																:
																rew.target_group === "CATEGORY" ?
																	<div className="row">
																		<img src={rew.offerLogo === "" || rew.offerLogo === null  ? `${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_merchant_offer.png` : rew.offerLogo}
																			className="rounded-circle" style={{ width: "75px", height: "50px" }} />
																		<div className="col fw-bold align-content-center">{
																			rew.merchantName && rew.merchantName !== null ? rew.merchantName : language?.static_labels.agnostic_category_offer
																		}</div>
																	</div>
																	: rew.target_group === "CARD_HOLDER" ?
																		<div className="row">
																			<img src={rew.offerLogo === "" || rew.offerLogo === null  ? `https://voxprod-cdn.pulseid.com/visa-japan-email/agnostic-merchant-logo.png`
																				: rew.offerLogo}
																				className="rounded-circle" style={{ width: "75px", height: "50px" }} />
																			<div className="col fw-bold align-content-center">{
																				rew.merchantName && rew.merchantName !== null ? rew.merchantName : language?.static_labels.agnostic_cardholder_offer
																			}</div>
																		</div>
																		: <div className="row">
																			<img src={rew.offerLogo === "" || rew.offerLogo === null  ? rew.merchantImage : rew.offerLogo}
																				className="rounded-circle" style={{ width: "75px", height: "50px" }} />
																			<div className="col fw-bold align-content-center">{rew.merchantName}</div>
																		</div>
														}


													</td>
													<td className="align-content-center">
														<div><span style={{ color: "#000" }}>*</span>{new Date(rew.txDateUtc).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}</div>
														<div className="text-secondary">{new Date(rew.txDateUtc).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })}</div>
													</td>
													<td scope="row" className="align-content-center text-ellipsis" title={(rew.alias) ? rew.alias : rew.last_four}>
														{
															(rew.alias) ? rew.alias : rew.last_four
														}
													</td>
													<td className="text-start align-content-center text-ellipsis">
														{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(rew.txAmount).toFixed(0)}
														{
															// (filteredRewards[index + 1]?.transactionId === rew.transactionId) ?
															(rew.isEligible) ?
																<span class="badge text-bg-secondary ms-2 qualified-badge p-2">{language?.static_labels.overview_table_qualified}</span>
																: ""
														}
													</td>
													<td className="text-start align-content-cente text-ellipsis">
														{
															(rew.rewardStatus === "CREDIT PENDING" || rew.rewardStatus === "REWARD ISSUED" || rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
																<i class="bi bi-circle-fill me-2 cachback_status_pending"></i>
																:
																(rew.rewardStatus === "CREDIT SUCCESSFUL") ?
																	<i class="bi bi-circle-fill me-2 cachback_status_success"></i>
																	: ""
															// (rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
															// 	<i class="bi bi-circle-fill me-2 cachback_status_failed"></i>
															// 	: ""
														}
														{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(rew.rewardAmount).toFixed(0)}
													</td>
													<td className="align-content-center" ><a className="fw-semibold" style={{ color: "#1C4AEB", cursor: "pointer" }} onClick={() => {
														rew.isQualified = rew.isEligible //(filteredRewards[index + 1]?.transactionId === rew.transactionId)
														setSelectedTransaction(rew)
														sethideOverview("d-none");
														setshowDetail("d-block")
													}}>{language?.static_labels.overview_table_view}</a></td>

												</tr> : ""

											:
											(rew.rewardStatus === "REWARD ISSUED"
												|| rew.rewardStatus === "CREDIT PENDING"
												|| rew.rewardStatus === "CREDIT SUCCESSFUL"
												|| rew.rewardStatus === "CREDIT UNSUCCESSFUL"
												|| rew.rewardStatus === "CREDIT FAILED") ?
												<tr>
													<td scope="row" className="align-content-center">{rew.transactionId}</td>
													<td className="align-content-center">
														<div className="row">
															<img src={`${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg`}
																className="rounded-circle" style={{ width: "75px", height: "50px" }} />
															<div className="col fw-bold align-content-center">{language?.static_labels.overview_table_bonus_merchant}</div>
														</div>
													</td>
													<td className="align-content-center">
														<div>{new Date(rew.bonusRewardDate).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}</div>
														<div className="text-secondary">{new Date(rew.bonusRewardDate).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })}</div>
													</td>
													<td scope="row" className="align-content-center text-ellipsis" title={(rew.alias) ? rew.alias : rew.last_four}>
														{
															(rew.alias) ? rew.alias : rew.last_four
														}
													</td>
													<td className="text-end align-content-center"></td>
													<td className="text-start align-content-center text-ellipsis">
														{
															(rew.rewardStatus === "CREDIT PENDING" || rew.rewardStatus === "REWARD ISSUED" || rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
																<i class="bi bi-circle-fill me-2 cachback_status_pending"></i>
																:
																(rew.rewardStatus === "CREDIT SUCCESSFUL") ?
																	<i class="bi bi-circle-fill me-2 cachback_status_success"></i>
																	// :
																	// (rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
																	// 	<i class="bi bi-circle-fill me-2 cachback_status_failed"></i>
																	: ""
														}
														{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(rew.bonusAmount).toFixed(0)}
													</td>
													<td className="align-content-center">
														<a className="fw-semibold" style={{ color: "#1C4AEB", cursor: "pointer" }} onClick={() => {
															rew.isQualified = rew.isEligible //(filteredRewards[index + 1]?.transactionId === rew.transactionId)
															setSelectedTransaction(rew)
															sethideOverview("d-none");
															setshowDetail("d-block")
														}}>{language?.static_labels.overview_table_view}</a>
													</td>

												</tr> : ""
									})
								}
							</tbody>
						</table>
					</div>
					{filteredRewards?.some(rew => rew.reward_id === null) && (
						<div className="row fs-12">
							<label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_table_below_text}</label>
							<label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_table_below_text_2}</label>
						</div>
					)}
				</div>
				{/* END <!-- Desktop-specific content here --> */}

				{/* START <!-- Mobile-specific content here --> */}
				<div className="d-block d-md-none">
					<div className={`${showFilter ? "d-block" : "d-none"} pb-3 mb-2`}>

						<div className="row">
							<div className="col-12 mb-3">
								{/* <label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_by_date}</label> */}

								<div className={`bg-white border border-1 form-control`}>
									<DateRangePicker
										locale={language?.languagecodedate}
										onChange={item => {
											changeDates(item);
										}}
										value={filterDates}
										dayPlaceholder="DD"
										monthPlaceholder="MM"
										yearPlaceholder="YY"
										rangeDivider="-"
										format="yyyy/MM/dd"
									// className={"fs-12 ps-2 pe-2"}
									/>
								</div>
							</div>

							<div className="col">
								{/* <label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_by_merchant}</label> */}
								<div>
									<select className="form-select fs-12" ref={filRefCatM} onChange={(event) => filterRewards(event.target.value)}>
										<option value="0">{language?.static_labels.overview_all_merchants}</option>
										{

											cbMerchantList?.map((merchant) => {
												return <option value={merchant.merchantId}>{merchant.merchantName}</option>
											})
										}
									</select>
								</div>
							</div>
						</div>

					</div>
					<div className="row mt-3 mb-5" style={{ fontSize: "11px" }}>
						<div className="text-start">
							<div className="d-inline-block text-ellipsis" style={{ width: "43%" }}>
								<i class="bi bi-circle-fill me-2 cachback_status_success"></i>{language?.static_labels.overview_status_success}
							</div>
							<div className="d-inline-block ms-2 text-ellipsis" style={{ width: "44%" }}>
								<i class="bi bi-circle-fill me-2 cachback_status_pending"></i>{language?.static_labels.overview_status_pending}
							</div>
							{/* <div className="d-inline-block ms-2 text-ellipsis" style={{ width: "31%" }}>
								<i class="bi bi-circle-fill me-2 cachback_status_failed"></i>{language?.static_labels.overview_status_failed}
							</div> */}
						</div>
					</div>

					{
						filteredRewards?.map((rew, index) => {
							return (rew.reward_id === null) ?
								(rew.rewardStatus === "REWARD ISSUED"
									|| rew.rewardStatus === "CREDIT PENDING"
									|| rew.rewardStatus === "CREDIT SUCCESSFUL"
									|| rew.rewardStatus === "CREDIT UNSUCCESSFUL"
									|| rew.rewardStatus === "CREDIT FAILED") ?
									<div className="row pt-2 pb-2 border-bottom mob-cashback-row"
										onClick={() => {
											rew.isQualified = rew.isEligible //(filteredRewards[index + 1]?.transactionId === rew.transactionId)
											setSelectedTransaction(rew)
											sethideOverview("d-none");
											setHideCommon("d-none");
											setshowDetail("d-block");
										}}>
										<div class="border overflow-hidden p-0 rounded-circle" style={{
											fontSize: "50px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "50px", height: "50px"
										}}>
									
											{

												rew.target_group === "MERCHANT" ?
													<img src={`${rew.offerLogo === "" || rew.offerLogo === null ? rew.merchantImage : rew.offerLogo}`} className="d-block ms-auto me-auto" style={{ width: "75px", height: "50px" }} />

													// <img src={`${rew.offerLogo === "" || rew.offerLogo === null  ? "" : rew.offerLogo}`} className="d-block ms-auto me-auto" style={{ width: "75px", height: "50px" }} />
													:
													rew.target_group === "CATEGORY" ?
														<img src={`${rew.offerLogo === "" || rew.offerLogo === null  ? "" : rew.offerLogo}`} className="d-block ms-auto me-auto" style={{ width: "75px", height: "50px" }} />
														: rew.target_group === "CARD_HOLDER" ?
															<img src={`${rew.offerLogo === "" || rew.offerLogo === null  ? "https://voxprod-cdn.pulseid.com/visa-japan-email/agnostic-merchant-logo.png" : rew.offerLogo}`} className="d-block ms-auto me-auto" style={{ width: "75px", height: "50px" }} />
															:
															<img src={`${rew.offerLogo === "" || rew.offerLogo === null  ? rew.merchantImage : rew.offerLogo}`} className="d-block ms-auto me-auto" style={{ width: "75px", height: "50px" }} />
											}
										</div>

										<div className="fs-12 col align-content-center">

											{
												rew.target_group === "MERCHANT" ?
													<strong>{rew.merchantName}</strong>
													// <strong>{language?.static_labels.agnostic_merchant_offer}</strong>
													:
													rew.target_group === "CATEGORY" ?
														<strong>{language?.static_labels.agnostic_category_offer}</strong>
														: rew.target_group === "CARD_HOLDER" ?
															<strong>{language?.static_labels.agnostic_cardholder_offer}</strong>
															:
															<strong>{rew.merchantName}</strong>
											}

											<br />
											<div className="text-secondary">{new Date(rew.txDateUtc).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}</div>

										</div>
										<div className="fs-12 col text-end align-content-center">

											{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(rew.rewardAmount).toFixed(0)}
											{
												(rew.rewardStatus === "CREDIT PENDING" || rew.rewardStatus === "REWARD ISSUED" || rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
													<i class="bi bi-circle-fill ms-2 cachback_status_pending"></i>
													:
													(rew.rewardStatus === "CREDIT SUCCESSFUL") ?
														<i class="bi bi-circle-fill ms-2 cachback_status_success"></i>
														// :
														// (rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
														// 	<i class="bi bi-circle-fill ms-2 cachback_status_failed"></i>
														: ""
											}
										</div>
									</div> : ""
								:
								(rew.rewardStatus === "REWARD ISSUED"
									|| rew.rewardStatus === "CREDIT PENDING"
									|| rew.rewardStatus === "CREDIT SUCCESSFUL"
									|| rew.rewardStatus === "CREDIT UNSUCCESSFUL"
									|| rew.rewardStatus === "CREDIT FAILED") ?
									<div className="row pt-2 pb-2 border-bottom mob-cashback-row"
										onClick={() => {
											rew.isQualified = rew.isEligible //(filteredRewards[index + 1]?.transactionId === rew.transactionId)
											setSelectedTransaction(rew)
											sethideOverview("d-none");
											setHideCommon("d-none");
											setshowDetail("d-block");
										}}>
										<div class="border overflow-hidden p-0 rounded-circle" style={{
											fontSize: "50px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "50px", height: "50px"
										}}>
											<img src={`${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg`} style={{ width: "75px", height: "50px" }} className="d-block ms-auto me-auto" />
										</div>

										<div className="fs-12 col align-content-center">

											<strong>{language?.static_labels.overview_table_bonus_merchant}</strong><br />
											<div className="text-secondary">{new Date(rew.bonusRewardDate).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}</div>

										</div>
										<div className="fs-12 col text-end align-content-center">

											{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(rew.rewardAmount).toFixed(0)}
											{
												(rew.rewardStatus === "CREDIT PENDING" || rew.rewardStatus === "REWARD ISSUED" || rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
													<i class="bi bi-circle-fill ms-2 cachback_status_pending"></i>
													:
													(rew.rewardStatus === "CREDIT SUCCESSFUL") ?
														<i class="bi bi-circle-fill ms-2 cachback_status_success"></i>
														// :
														// (rew.rewardStatus === "CREDIT UNSUCCESSFUL" || rew.rewardStatus === "CREDIT FAILED") ?
														// 	<i class="bi bi-circle-fill ms-2 cachback_status_failed"></i>
														: ""
											}
										</div>
									</div> : ""
						})
					}
					{filteredRewards?.some(rew => rew.reward_id === null) && (
						<div className="row">
							<label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_table_below_text}</label>
							<label className='fs-12 text-secondary fw-bold'>{language?.static_labels.overview_table_below_text_2}</label>
						</div>
					)}
				</div>
				{/* END <!-- Mobile-specific content here --> */}
			</div>


			<div>
				{/* START <!-- Desktop-specific content here --> */}
				<div className='d-none d-md-block'>
					<div style={{ backgroundColor: "#f0f0f0" }} className={`${showDetail} pt-5 h-100`}>
						<div className='w-50 p-4 bg-white m-auto mt-5 rounded-3'>
							<div>
								<div class="border overflow-hidden p-0 rounded-circle m-auto" style={{
									fontSize: "50px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "72px", height: "72px"
								}}>
									<img src={`${(selectedTransaction.reward_id) ? `${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg` : selectedTransaction.merchantImage}`} className="d-block ms-auto me-auto" style={{ width: "100%", height: "100%" }} />
								</div>
								<div className='text-center mt-2 fw-bold fs-20'>
									{tenant?.tenantmasterconfig.common.currency_symbol + parseFloat(selectedTransaction.rewardAmount).toFixed(0)}
								</div>
								<div className='text-center fs-12 fw-semibold'>
									{language?.static_labels.overview_detail_bonus_cashback}
								</div>
							</div>
							<div className='mt-5  fs-12'>
								<div className='row mb-4'>
									<div className='col fw-bold text-secondary'>
										{language?.static_labels.overview_detail_id}
									</div>
									<div className='col text-end'>
										{(selectedTransaction.reward_id) ? selectedTransaction.reward_id : selectedTransaction.transactionId}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col fw-bold text-secondary'>
										{language?.static_labels.overview_detail_merchant}
									</div>
									<div className='col text-end'>
										{(selectedTransaction.reward_id) ? language?.static_labels.overview_table_bonus_merchant : selectedTransaction.merchantName}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col fw-bold text-secondary'>
										{language?.static_labels.overview_detail_status}
									</div>
									<div className='col text-end'>
										{
											(selectedTransaction.rewardStatus === "CREDIT PENDING" || selectedTransaction.rewardStatus === "REWARD ISSUED" || selectedTransaction.rewardStatus === "CREDIT UNSUCCESSFUL" || selectedTransaction.rewardStatus === "CREDIT FAILED") ?
												<div><i class="bi bi-circle-fill me-2 cachback_status_pending"></i>{language?.static_labels.overview_status_pending}</div>
												:
												(selectedTransaction.rewardStatus === "CREDIT SUCCESSFUL") ?
													<div><i class="bi bi-circle-fill me-2 cachback_status_success"></i>{language?.static_labels.overview_status_success}</div>
													// :
													// (selectedTransaction.rewardStatus === "CREDIT UNSUCCESSFUL" || selectedTransaction.rewardStatus === "CREDIT FAILED") ?
													// 	<div><i class="bi bi-circle-fill me-2 cachback_status_failed"></i>{language?.static_labels.overview_status_failed}</div>
													: ""
										}
										{/* {selectedTransaction.rewardStatus} */}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col fw-bold text-secondary'>
										{language?.static_labels.overview_detail_transaction_date}
									</div>
									<div className='col text-end'>
										{
											(selectedTransaction.reward_id) ?
												<div>
													{new Date(selectedTransaction.bonusRewardDate).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}
													&nbsp;
													{new Date(selectedTransaction.bonusRewardDate).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })}
												</div>
												:
												<div>
													<span style={{ color: "#000" }}>*</span>
													{new Date(selectedTransaction.txDateUtc).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}
													&nbsp;
													{new Date(selectedTransaction.txDateUtc).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })}
												</div>
										}

									</div>
								</div>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>
										{language?.static_labels.overview_detail_card_last4_alias}
									</div>
									<div className='col text-end'>
										{
											(selectedTransaction.alias) ? selectedTransaction.alias : selectedTransaction.last_four
										}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col fw-bold text-secondary'>
										{language?.static_labels.overview_detail_transaction_amount}
									</div>
									{
										(selectedTransaction.reward_id) ?
											<div className='col text-end'>N/A</div>
											:
											<div className='col text-end'>
												{
													(selectedTransaction.isQualified) ?
														<span class="badge text-bg-secondary ms-2 qualified-badge p-2">{language?.static_labels.overview_detail_qualified}</span>
														: ""
												}
												&nbsp;{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(selectedTransaction.txAmount).toFixed(0)}
											</div>


									}
								</div>
							</div>
						</div>
						<div className='text-center mt-3 mb-5'>
							<a className='fs-12 fw-bold' style={{ cursor: 'pointer', color: "#002FD1" }} onClick={() => {
								sethideOverview("d-block"); setshowDetail("d-none");
								setHideCommon("d-block");
							}}><div style={{ display: "inline", position: "relative" }}>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<i class="bi bi-arrow-left" style={{ position: "absolute", top: "1px", left: "0px" }}></i> {language?.static_labels.overview_detail_back}</div>
							</a>
						</div>

					</div>
				</div>
				{/* END <!-- Desktop-specific content here --> */}

				{/* START <!-- Mobile-specific content here --> */}
				<div className='d-block d-md-none row'>

					<div style={{ backgroundColor: "#f0f0f0" }} className={`${showDetail} col h-100 mt-5 rounded-5`}>

						<div style={{ top: "-35px", position: "relative" }}>
							<div class="bg-white border m-auto overflow-hidden p-2 rounded-circle" style={{
								fontSize: "50px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "72px", height: "72px"
							}}>
								<img src={`${(selectedTransaction.reward_id) ? `${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg` : selectedTransaction.merchantImage}`} className="d-block me-auto ms-auto rounded-circle" style={{ width: "100%", height: "100%" }} />
							</div>
							<div className='text-center mt-2 fw-bold fs-20'>
								{tenant?.tenantmasterconfig.common.currency_symbol + parseFloat(selectedTransaction.rewardAmount).toFixed(0)}
							</div>
							<div className='text-center fs-12 fw-semibold'>
								{language?.static_labels.overview_detail_cashback}
							</div>
						</div>


						<div className='w-100 p-4 bg-white m-auto rounded-3'>

							<div className='mt-4  fs-12'>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>
										{language?.static_labels.overview_detail_id}
									</div>
									<div className='col text-end'>
										{(selectedTransaction.reward_id) ? selectedTransaction.reward_id : selectedTransaction.transactionId}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>
										{language?.static_labels.overview_detail_merchant}
									</div>
									<div className='col text-end'>
										{(selectedTransaction.reward_id) ? language?.static_labels.overview_table_bonus_merchant : selectedTransaction.merchantName}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>

										{language?.static_labels.overview_detail_status}
									</div>
									<div className='col text-end'>
										{
											(selectedTransaction.rewardStatus === "CREDIT PENDING" || selectedTransaction.rewardStatus === "REWARD ISSUED" || selectedTransaction.rewardStatus === "CREDIT UNSUCCESSFUL" || selectedTransaction.rewardStatus === "CREDIT FAILED") ?
												<div><i class="bi bi-circle-fill me-2 cachback_status_pending"></i>{language?.static_labels.overview_status_pending}</div>
												:
												(selectedTransaction.rewardStatus === "CREDIT SUCCESSFUL") ?
													<div><i class="bi bi-circle-fill me-2 cachback_status_success"></i>{language?.static_labels.overview_status_success}</div>
													// :
													// (selectedTransaction.rewardStatus === "CREDIT UNSUCCESSFUL" || selectedTransaction.rewardStatus === "CREDIT FAILED") ?
													// 	<div><i class="bi bi-circle-fill me-2 cachback_status_failed"></i>{language?.static_labels.overview_status_failed}</div>
													: ""
										}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>
										{language?.static_labels.overview_detail_transaction_date}
									</div>
									<div className='col text-end'>
										{
											(selectedTransaction.reward_id) ?
												<div>
													{new Date(selectedTransaction.bonusRewardDate).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}
													&nbsp;
													{new Date(selectedTransaction.bonusRewardDate).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })}
												</div>
												:
												<div>
													<span style={{ color: "#000" }}>*</span>
													{new Date(selectedTransaction.txDateUtc).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' })}
													&nbsp;
													{new Date(selectedTransaction.txDateUtc).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })}
												</div>
										}

									</div>
								</div>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>
										{language?.static_labels.overview_detail_card_last4_alias}
									</div>
									<div className='col text-end'>
										{
											(selectedTransaction.alias) ? selectedTransaction.alias : selectedTransaction.last_four
										}
									</div>
								</div>
								<div className='row mb-4'>
									<div className='col-5 fw-bold text-secondary'>
										{language?.static_labels.overview_detail_transaction_amount}
									</div>
									{
										(selectedTransaction.reward_id) ?
											<div className='col text-end'>N/A</div>
											:
											<div className='col text-end'>
												{
													(selectedTransaction.isQualified) ?
														<span class="badge text-bg-secondary ms-2 qualified-badge p-2">{language?.static_labels.overview_detail_qualified}</span>
														: ""
												}
												&nbsp;{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(selectedTransaction.txAmount).toFixed(0)}
											</div>


									}
								</div>
							</div>
						</div>
						<div className='text-center mt-3 mb-5'>
							<a className='fs-12 fw-bold' style={{ cursor: 'pointer', color: "#002FD1" }} onClick={() => {
								sethideOverview("d-block");
								setHideCommon("d-block"); setshowDetail("d-none")
							}}>
								<div style={{ display: "inline", position: "relative" }}>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<i class="bi bi-arrow-left" style={{ position: "absolute", top: "1px", left: "0px" }}></i> {language?.static_labels.overview_detail_back}</div>
							</a>
						</div>

					</div>
				</div>
				{/* END <!-- Mobile-specific content here --> */}
			</div>

		</div>
	);
}
